import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidShoppingBagIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18 7h-2V6c0-2.2-1.8-4-4-4S8 3.8 8 6v1H6c-1.1 0-2 .9-2 2v10c0 1.7 1.3 3 3 3h10c1.7 0 3-1.3 3-3V9c0-1.1-.9-2-2-2Zm-8-1c0-1.1.9-2 2-2s2 .9 2 2v1h-4V6Z"/>
  </SvgIcon>
}

export default SolidShoppingBagIcon
